var map = {
	"./1.jpg": 6230,
	"./IMG_5623.jpg": 53079,
	"./IMG_5625.jpg": 82380,
	"./IMG_5627.jpg": 64071,
	"./IMG_5637.jpg": 28234,
	"./IMG_5638.jpg": 59677,
	"./IMG_5641.jpg": 39838,
	"./IMG_5656.jpg": 24823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44575;